//用户
import Users from "@/views/systerm/userConfig/user/Users.vue"; //
import UserItem from "@/views/systerm/userConfig/user/UserItem.vue"; //用户配置首页
// import UserInfo from '@/views/systerm/userConfig/user/UserInfo.vue' //用户配置
import UserHistory from "@/views/systerm/userConfig/user/UserHistory.vue"; //用户配置
import UserPreferences from "@/views/systerm/userConfig/user/UserPreferences.vue"; //用户配置
import UserAuthorization from "@/views/systerm/userConfig/user/UserAuthorization.vue"; //用户配置
import UserGroup from "@/views/systerm/userConfig/user/UserGroup.vue"; //用户配置
import CreateUser from "@/views/systerm/userConfig/user/CreateUser.vue"; //用户创建
import RolePermission from "@/views/systerm/userConfig/user/RolePermission.vue"; //用户-角色权限
//管理员修改用户密码
import AdminUpdatePsd from "@/views/systerm/userConfig/user/adminUpdatePsd.vue"; //密码修改

import { ItemAttachment, Relationship, PageInfo } from "./commonModules";

export const UsersPage = [
  {
    path: "/users",
    component: Users,
    children: [
      {
        path: "UserInfo",
        component: PageInfo,
      },
      {
        path: "RolePermission",
        component: RolePermission,
      },
      {
        path: "UserPreferences",
        component: UserPreferences,
      },
      {
        path: "UserAuthorization",
        component: UserAuthorization,
      },
      {
        path: "UserGroup",
        component: UserGroup,
      },
      {
        path: "UserAttachment",
        component: ItemAttachment,
      },
      {
        path: "UserHistory",
        component: UserHistory,
      },
    ],
  },
  {
    path: "/createUser",
    component: CreateUser,
  },
  {
    path: "/adminUpdatePsd",
    component: AdminUpdatePsd,
  },
  {
    path: "/UserItem",
    component: UserItem,
    children: [
      {
        path: "/UserInfo",
        component: PageInfo,
      },
      {
        path: "/UserAttachment",
        component: ItemAttachment,
      },
      {
        path: "/UserAttachment2",
        component: ItemAttachment,
      },
      {
        path: "/UserHistory",
        component: UserHistory,
      },
      {
        path: "/UserGroup",
        component: UserGroup,
      },
      {
        path: "/UserAuthorization",
        component: UserAuthorization,
        name: UserAuthorization,
      },
      {
        path: "/UserPreferences",
        component: UserPreferences,
        name: UserPreferences,
      },
    ],
  },
];
